import { projectType } from "/@src/views/app/project/ProjectType";
import {
  ADD_VARIANT,
  DELETE_VARIANT,
  SAVE_PROJECT_RESOURCE,
  SAVE_VARIANT,
  SET_MODEL,
  SET_PROJECT_DETAILS_SETTING,
  SET_PROJECT_EDITOR,
  SET_PROJECT_EDITOR_LOADING,
} from "../contants";
import { mediaHost } from "/@src/constants/defaultValues";

export const visualizerDefaultDetails = {
  src: "",
  iosSrc: "",
  poster: "",
  disableZoom: false,
  autoRotate: false,
  skyboxImage: "",
  arPlacement: "floor",
  arScale: "auto",
  autoPlay: false,
  variants: {},
  cta: {
    text: "",
    type: "email",
    value: "",
  },
};

const arCardDefaults = {
  cardImg: `${mediaHost}/ar-card-template/example-business-card.webp`,
  profileImg: `${mediaHost}/ar-card-template/avatar2.png`,
  video: null,
  ctas: [
    {
      title: "WEBSITE",
      color: "#33ac63",
      textColor: "#fff",
      link: "yourwebsite.com",
    },
    {
      title: "LINKEDIN",
      color: "#3998c7",
      textColor: "#ffffff",
      link: "linkedin.com",
    },
  ],
  menus: [
    {
      iconUrl: `${mediaHost}/ar-card-template/icons/3.png`,
      type: "email",
      value: "contact@email.com",
    },
    {
      iconUrl: `${mediaHost}/ar-card-template/icons/13.png`,
      type: "sms",
      value: "18000000",
    },
    {
      iconUrl: `${mediaHost}/ar-card-template/icons/17.png`,
      type: "phone",
      value: "18000000",
    },
    {
      iconUrl: `${mediaHost}/ar-card-template/icons/12.png`,
      type: "other",
      value: "fb.com",
    },
  ],
};

const initialState = {
  project: null,
  details: {},
  model: null,
  loading: false,
  projectChanged: false,
  materialDefaults: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROJECT_EDITOR: {
      const { project, projectResource } = action.payload;

      let details = {};
      if (project.type === projectType.PRODUCT_VISUALIZER) {
        details = {
          ...visualizerDefaultDetails,
          ...projectResource?.details,
        };
      }
      if (project.type === projectType.AR_CARD) {
        details = {
          ...arCardDefaults,
          ...projectResource?.details,
        };
      }
      if (project.type === projectType.ECOMMERCE) {
        details = {
          ...visualizerDefaultDetails,
          ...projectResource?.details,
        };
      }

      return {
        ...state,
        project,
        details: {
          ...details,
        },
        resource: {
          ...projectResource
        },
        projectChanged: false,
        loading: false,
      };
    }
    case SET_PROJECT_EDITOR_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case SET_PROJECT_DETAILS_SETTING: {
      const { prop, value } = action.payload;
      return {
        ...state,
        details: {
          ...state.details,
          [prop]: value,
        },
        projectChanged: true,
      };
    }
    case ADD_VARIANT:
    case SAVE_VARIANT: {
      const { id } = action.payload;
      return {
        ...state,
        projectChanged: true,
        details: {
          ...state.details,
          variants: {
            ...state.details.variants,
            [id]: action.payload,
          },
        },
      };
    }
    case DELETE_VARIANT: {
      const id = action.payload;
      const currentVariants = state.details?.variants;
      if (currentVariants && currentVariants[id]) {
        delete currentVariants[id];
      }

      return {
        ...state,
        projectChanged: true,
        details: {
          ...state.details,
          variants: {
            ...currentVariants,
          },
        },
      };
    }
    case SAVE_PROJECT_RESOURCE: {
      return {
        ...state,
        projectChanged: false,
        projectUpdated: Date.now()
      };
    }
    case SET_MODEL: {
      const model = action.payload;
      const materialDefaults = {};
      const materials = model?.model?.materials || [];
      for (const m of materials) {
        let { name, pbrMetallicRoughness } = m;
        materialDefaults[name] = {
          name,
          baseColorFactor: pbrMetallicRoughness.baseColorFactor,
          baseColorTexture: pbrMetallicRoughness.baseColorTexture.texture,
          alphaMode: m.getAlphaMode()
        };
      }
      return {
        ...state,
        model: action.payload,
        materialDefaults,
      };
    }

    default:
      return state;
  }
};
export default reducer;
